<template>
  <div>
    <div class="feet">
      <!--下载模板-->
      <el-button type="primary" size="small" @click="downloadTemplate">{{ $t('basicData.DownloadTheTemplate') }}</el-button>
      <!--导入分区-->
      <upload-excel
        class="feet-btn"
        :on-success="importLogistics"
        :but-name="fileName"
      />
      <!--下载分区-->
      <el-button type="primary" size="small" @click="downloadPartition">{{ $t('basicData.DownloadThePartition') }}</el-button>
    </div>

    <!--导入结果提示-->
    <el-dialog
      :title="$t('basicData.tips')"
      :visible.sync="importDialogVisible"
      :append-to-body="true"
      width="30%"
    >
      <div>
        <div v-for="(item, ind) in errData" :key="ind" style="color: red;margin-bottom: 10px;">{{ item }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="importDialogVisible = false">{{ $t('basicData.determine') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { saveAs } from 'file-saver';
const ExcelJs = require('exceljs');
import { Loading } from 'element-ui';
import { checkZipCode } from './utils';

const loadingOptions = {
  lock: true,
  spinner: 'el-icon-loading',
  text: 'loading...',
  background: 'rgba(250, 250, 250, 0.6)' // loading background
};

// 收发件维度枚举
const SENDER_DIM_CITY = 2; // 发件维度 城市
const SENDER_DIM_AREA = 3; // 发件维度 区域
const SENDER_DIM_STATE = 4; // 发件维度 州
const RECEIVE_DIM_ZIP = 1; // 收件维度 邮编
const RECEIVE_DIM_CITY = 2; // 收件维度 城市
const RECEIVE_DIM_AREA = 3; // 收件维度 区域
const RECEIVE_DIM_STATE = 4; // 收件维度 州

// 在模板中保留足够的空行，以便下拉粘贴
const BLANK_OPTION_ROWS = 50000;

// 1 -> A, 2 -> B, ...
function colName(index) {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let name = '';
  let value = index;
  while (value > 0) {
    const r = (value - 1) % 26;
    name = letters[r] + name;
    value = Math.floor((value - 1) / 26);
  }
  return name;
}

export default {
  name: 'ImportPartition',
  components: {
    'upload-excel': () => import('@/components/UploadExcel/index')
  },
  props: {
    tableData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 发件维度：0/null表示未参与；2表示城市，3表示区域，4表示州
    senderDimension: {
      type: Number,
      default: 0
    },
    // 收件人维度：1 邮政编码 2 城市 3 区域 4 州
    receiverDimension: {
      type: Number,
      default: 1
    },
    // 所有州
    stateList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 所有城市
    allCity: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 区域选项
    areaList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      errData: [],
      importDialogVisible: false
    };
  },
  computed: {
    fileName() {
      return this.$t('basicData.ImportPartitions');
    },
    dim() {
      return Number(this.receiverDimension) || RECEIVE_DIM_ZIP;
    },
    senderDim() {
      return Number(this.senderDimension) || null;
    },
    isZip() {
      return this.dim === RECEIVE_DIM_ZIP;
    },
    hasSender() {
      return [SENDER_DIM_CITY, SENDER_DIM_AREA, SENDER_DIM_STATE].includes(this.senderDim);
    },
    // 发件维度列标题随发件维度变化
    senderHeaderText() {
      const map = {
        [SENDER_DIM_AREA]: 'basicData.SenderAreaColumn',
        [SENDER_DIM_CITY]: 'basicData.SenderCityColumn',
        [SENDER_DIM_STATE]: 'basicData.SenderStateColumn'
      };
      return this.$t(map[this.senderDim] || 'basicData.SenderStateColumn');
    },
    // 收件维度列标题随接收方维度变化
    receiverHeaderText() {
      const map = {
        [RECEIVE_DIM_ZIP]: 'basicData.ReceiverZipColumn',
        [RECEIVE_DIM_CITY]: 'basicData.ReceiverCityColumn',
        [RECEIVE_DIM_AREA]: 'basicData.ReceiverAreaColumn',
        [RECEIVE_DIM_STATE]: 'basicData.ReceiverStateColumn'
      };
      return this.$t(map[this.dim] || map[RECEIVE_DIM_ZIP]);
    },
    senderOptionTokens() {
      if (!this.hasSender) {
        return [];
      }
      return this.optionTokens(this.senderDim);
    },
    receiverOptionTokens() {
      if (this.isZip) {
        return [];
      }
      return this.optionTokens(this.dim);
    },
    noteText() {
      if (this.isZip) {
        return this.$t('basicData.PartitionImportRules');
      }
      return this.$t('basicData.ImportReceiverNote', { dim: this.receiverHeaderText });
    },
    templateFileName() {
      return this.$t('basicData.PartitionImportTemplate') + '(' + this.receiverHeaderText + ').xlsx';
    }
  },
  methods: {
    cityPrefix(item) {
      return item.parentNode && item.parentNode.twoCode ? item.parentNode.twoCode + '->' : '';
    },
    // 为给定维度构建原始元数据
    optionMeta(dim) {
      if (dim === SENDER_DIM_AREA || dim === RECEIVE_DIM_AREA) {
        // 重组区域选项
        return this.areaList.map(item => ({
          value: item.dictValue,
          name: item.dictName || item.label || item.name || '',
          token: (item.dictName || item.label || item.name || '') + '->' + item.dictValue
        }));
      }
      if (dim === SENDER_DIM_CITY || dim === RECEIVE_DIM_CITY) {
        // 重组城市选项
        return this.allCity.map(item => {
          const prefix = this.cityPrefix(item);
          const name = item.name || item.label || '';
          return {
            value: Number(item.value),
            name,
            token: prefix + name + '->' + item.value
          };
        });
      }
      // 重组城市选项
      return this.stateList.map(item => ({
        value: Number(item.value),
        name: item.label || item.name || '',
        token: (item.label || item.name || '') + '->' + item.value
      }));
    },
    optionTokens(dim) {
      return this.optionMeta(dim).map(item => item.token);
    },
    // 将存储的值转换为Excel中使用的选项文本
    valueToOptionText(value, dim) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      const meta = this.optionMeta(dim).find(item => String(item.value) === String(value));
      return meta ? meta.token : '';
    },
    // 重复错误接收器值的显示名称
    receiverOptionName(value) {
      const meta = this.optionMeta(this.dim).find(item => String(item.value) === String(value));
      return meta ? meta.name : String(value);
    },
    // 按维度将单个单元格标记解析为类型化值
    parseTokenValue(text, dim) {
      if (text === null || text === undefined) {
        return '';
      }
      const str = String(text).trim();
      if (!str) {
        return '';
      }
      const parts = str.split('->');
      const last = parts[parts.length - 1].trim();
      if (dim === SENDER_DIM_AREA || dim === RECEIVE_DIM_AREA) {
        return last;
      }
      const num = Number(last);
      return Number.isNaN(num) ? '' : num;
    },
    // 解析一个接收单元的多个值（用英文逗号分隔）
    parseReceiverValueList(text) {
      const out = [];
      const str = String(text === null || text === undefined ? '' : text).replace(/[，,]/g, ',').trim();
      if (!str) {
        return out;
      }
      str.split(',').forEach(token => {
        if (!token) {
          return;
        }
        const val = this.parseTokenValue(token, this.dim);
        if (val !== '' && val !== null && val !== undefined) {
          out.push(val);
        }
      });
      return out;
    },
    // 解析导入Excel单元格数据，没有值的返回''
    cellText(row, key) {
      const val = row[key];
      if (val === null || val === undefined) {
        return '';
      }
      return String(val);
    },
    // 处理空白行
    isBlankRow(row) {
      return Object.keys(row).every(key => {
        const val = row[key];
        return val === null || val === undefined || String(val).trim() === '';
      });
    },
    // 处理有数据的行
    rowToExport(item) {
      const out = {
        name: item.partitionIdentifier || ''
      };
      if (this.hasSender) {
        out.sender = this.valueToOptionText(item.state, this.senderDim);
      }
      if (this.isZip) {
        out.zipcode = item.postalCode || '';
      } else {
        const cityList = Array.isArray(item.city)
          ? item.city
          : (item.city !== null && item.city !== undefined && item.city !== '' ? [item.city] : []);
        out.receiver = cityList
          .map(value => this.valueToOptionText(value, this.dim))
          .filter(Boolean)
          .join(',');
      }
      out.id = item.id || '';
      return out;
    },
    // 添加选项表
    addOptionSheet(wb, name, header, tokens) {
      const sheet = wb.addWorksheet(name);
      sheet.columns = [
        {
          header,
          key: 'option',
          width: 60
        }
      ];
      sheet.addRows(tokens.map(token => ({ option: token })));
    },
    // 下载分区
    async buildWorkbook(type) {
      // 类型：1. 下载模板；2. 下载当前分区
      const wb = new ExcelJs.Workbook();
      const ws = wb.addWorksheet('Sheet1');
      const withId = type === 2;
      const columns = this.getColumns(withId);
      ws.columns = columns;
      const totalCols = columns.length;

      // 第2行的注释
      ws.mergeCells('A2:' + colName(totalCols) + '2');
      const noteCell = ws.getCell('A2');
      noteCell.value = this.noteText;
      noteCell.font = {
        color: { argb: 'FF0000' }
      };
      noteCell.alignment = { wrapText: true };
      ws.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };
      ws.getRow(1).height = 20;
      ws.getRow(2).height = 40;

      // 选项参考表
      let senderSheetName = '';
      let receiverSheetName = '';
      if (this.hasSender) {
        senderSheetName = this.isZip ? 'Sheet2' : 'Sheet3';
      }
      if (!this.isZip) {
        receiverSheetName = 'Sheet2';
      }
      if (senderSheetName) {
        this.addOptionSheet(wb, senderSheetName, this.senderHeaderText, this.senderOptionTokens);
      }
      if (receiverSheetName) {
        this.addOptionSheet(wb, receiverSheetName, this.receiverHeaderText, this.receiverOptionTokens);
      }

      if (type === 2) {
        const list = (this.tableData && this.tableData.partitionAffiliateList) || [];
        if (list.length) {
          ws.addRows(list.map(item => this.rowToExport(item)));
        }
      }

      // 数据从第3行开始；为下拉列表保留足够的空白行
      const targets = [];
      if (senderSheetName && this.senderOptionTokens.length) {
        targets.push({
          col: 2,
          sheet: senderSheetName,
          count: this.senderOptionTokens.length
        });
      }
      if (receiverSheetName && this.receiverOptionTokens.length) {
        targets.push({
          col: this.hasSender ? 3 : 2,
          sheet: receiverSheetName,
          count: this.receiverOptionTokens.length
        });
      }
      if (targets.length) {
        const dataRows = type === 2 && this.tableData && this.tableData.partitionAffiliateList
          ? this.tableData.partitionAffiliateList.length
          : 0;
        const maxRow = dataRows + BLANK_OPTION_ROWS;
        for (let row = 3; row <= maxRow; row += 1) {
          targets.forEach(target => {
            ws.getCell(row, target.col).dataValidation = {
              type: 'list',
              formulae: ['=' + target.sheet + '!$A$2:$A' + (target.count + 1)]
            };
          });
        }
      }

      const buffer = await wb.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const name = type === 1
        ? this.templateFileName
        : ((this.tableData && this.tableData.name ? this.tableData.name : 'partition') + '_' + new Date().getTime() + '.xlsx');
      saveAs(blob, name);
    },
    // 收发件维度生成模板表头
    getColumns(withId) {
      const columns = [
        {
          header: this.$t('basicData.PartitionName'),
          key: 'name',
          width: 40
        }
      ];
      if (this.hasSender) {
        columns.push({
          header: this.senderHeaderText,
          key: 'sender',
          width: 40
        });
      }
      if (this.isZip) {
        columns.push({
          header: this.receiverHeaderText,
          key: 'zipcode',
          width: 40
        });
      } else {
        columns.push({
          header: this.receiverHeaderText,
          key: 'receiver',
          width: 40
        });
      }
      if (withId) {
        columns.push({
          header: 'ID',
          key: 'id',
          width: 20
        });
      }
      return columns;
    },
    // 下载模板
    downloadTemplate() {
      this.buildWorkbook(1);
    },
    // 下载分区
    downloadPartition() {
      this.buildWorkbook(2);
    },
    // 将上传的Excel文件解析成行；验证规则与之前保持一致
    parseUpload(arr) {
      if (!arr || !arr.length || !arr[0] || !Array.isArray(arr[0].results)) {
        this.$message.error(this.$t('basicData.noTableDataParsed'));
        return { rows: [], errData: [] };
      }
      const results = (arr[0].results || []).slice(1); // 第一行是注释
      const errData = [];
      const rows = [];
      const isZip = this.isZip;
      const nameKey = this.$t('basicData.PartitionName');
      const receiverKey = this.receiverHeaderText;
      const idKey = 'ID';
      const senderKey = this.hasSender ? this.senderHeaderText : '';
      // 行间存在重复的接收器值（在保存时通过verifyRows检查是否压缩）
      const groupMap = new Map();

      results.forEach((row, ind) => {
        if (!row || this.isBlankRow(row)) {
          return;
        }
        const rowNo = ind + 1;
        const rowPrefix = this.$t('basicData.row') + rowNo + this.$t('basicData.line');
        const name = this.cellText(row, nameKey).trim();
        let state = '';
        if (this.hasSender) {
          state = this.parseTokenValue(this.cellText(row, senderKey), this.senderDim);
        }
        const id = this.cellText(row, idKey).trim();

        if (isZip) {
          const zipcode = this.cellText(row, receiverKey).trim().replace(/[，,]/g, ',');
          // 忽略没有分区名称或邮政编码的行（与之前相同）
          if (!name || !zipcode) {
            return;
          }
          rows.push({ name, state, zipcode, id });
        } else {
          if (!name) {
            errData.push(rowPrefix + this.$t('basicData.PartitionName') + this.$t('basicData.CannotBeEmpty'));
          }
          if (this.hasSender && state === '') {
            errData.push(rowPrefix + this.senderHeaderText + this.$t('basicData.CannotBeEmpty'));
          }
          const cityValues = this.parseReceiverValueList(this.cellText(row, receiverKey));
          rows.push({ name, state, city: cityValues, id });

          const senderKeyOfRow = this.hasSender
            ? String(state === null || state === undefined ? '' : state)
            : '';
          if (!groupMap.has(senderKeyOfRow)) {
            groupMap.set(senderKeyOfRow, new Map());
          }
          const subMap = groupMap.get(senderKeyOfRow);
          cityValues.forEach(value => {
            const valueKey = String(value);
            if (!subMap.has(valueKey)) {
              subMap.set(valueKey, []);
            }
            subMap.get(valueKey).push(rowNo);
          });
        }
      });

      groupMap.forEach(subMap => {
        subMap.forEach((rowNos, valueKey) => {
          if (rowNos.length > 1) {
            errData.push(
              this.$t('basicData.row') + rowNos.join('，') + this.$t('basicData.line') +
              this.$t('basicData.CannotSelectSameReceiver', { dim: this.receiverHeaderText }) +
              '【' + this.receiverOptionName(valueKey) + '】'
            );
          }
        });
      });

      // 收件维度=邮编：导入时同样做跨行邮编交集校验（与点击保存时一致；
      // 发件维度未参与时按整组校验，发件维度=州/区域/城市时按“发件值+邮编”组合分组校验）
      if (isZip && rows.length > 1) {
        const zipErrors = checkZipCode(rows.map(row => ({
          partitionIdentifier: row.name,
          postalCode: row.zipcode,
          state: row.state || ''
        })));
        errData.push(...zipErrors);
      }
      return { rows, errData };
    },
    importLogistics(arr) {
      const loadingInstance = Loading.service(loadingOptions);
      try {
        const result = this.parseUpload(arr);
        if (result.errData && result.errData.length > 0) {
          this.errData = result.errData;
          this.importDialogVisible = true;
        } else if (result.rows && result.rows.length > 0) {
          this.$emit('importPartition', result.rows);
        } else {
          this.$message.error(this.$t('collectionCenter.nullSubmit'));
        }
      } finally {
        loadingInstance.close();
      }
    }
  }
};
</script>

<style scoped>

</style>
